module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "type"
  }, [_c('div', {
    staticClass: "type__authorised",
    on: {
      "click": function($event) {
        _vm.toggleAuthorised(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('authorised')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daba6420"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overview/partials/Type.vue
// module id = 417
// module chunks = 1